module.exports = __webpack_public_path__ + "8814a4846c29d558a9ded3aaa645b3fb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-7.png
// module id = 3265
// module chunks = 0